import { Wrapper } from './styles'
import RadioInput from 'components/shared/Radio/input'
import { ReactNode } from 'react'

interface VoucherValueRadioProps {
    option: number | null
    id: string
    isChecked: boolean
    onClick: () => void
    children: ReactNode
    testId?: string
}

const VoucherValueRadio = ({
    option,
    id,
    isChecked,
    onClick,
    children,
    testId,
}: VoucherValueRadioProps) => (
    <Wrapper
        direction="row"
        align="center"
        justify="flex-start"
        gap={12}
        isChecked={isChecked}
        onClick={onClick}
        isFullWidth={!option}
        data-testid={testId}
    >
        <RadioInput option={`${option}`} id={id} isChecked={isChecked} />
        {children}
    </Wrapper>
)

export default VoucherValueRadio
